import React, { useState, useEffect } from "react";
import { Loading, Modal, Radio } from '@yisa/webui';
import ImgResize from '@/components/Bussiness/ImgResize'
import ajax from '@/services'

export default function ImgVideo(props) {
  const {
    visible,
    onCancel,
    modalWidth,
    data
  } = props;

  const { warn_img, warn_video } = data || {}
  const [type, setType] = useState('1')
  const [hasFetch, setHasFetch] = useState(false)
  const [loading, setLoading] = useState(false)
  const [videoSrc, setVideoSrc] = useState('')
  const finalVideoSrc = warn_video || videoSrc

  const typeOptions = [
    {
      label: '图片',
      value: '1'
    },
    {
      label: '视频',
      value: '2'
    }
  ]

  useEffect(() => {
    setType('1')
    setHasFetch(false)
    setVideoSrc('')
  }, [data])

  const handleChangeType = (e) => {
    const type = e.target.value
    if (type === '2') {
      if (!warn_video && !hasFetch) {
        setLoading(true)
        handleGetVideoSrc()
      }
    }
    setTimeout(() => {
      setType(type)
    }, 10)
  }

  const handleGetVideoSrc = () => {
    setHasFetch(true)
    ajax.getWarningVideo({
      id: data?.id
    }).then(res => {
      setVideoSrc(res?.data?.video_url || '')
    }).catch(err => {
      console.log(err)
    }).finally(() => {
      setLoading(false)
    })
  }

  return (
    <Modal
      title="查看大图"
      className="yisa-modal big-img-switch"
      onCancel={onCancel}
      footer={null}
      visible={visible}
      width={modalWidth}
      unmountOnExit={true}
    >
      <div className="img-main">
        <div className="img-main-header">
          <Radio.Group
            optionType="button"
            options={typeOptions}
            value={type}
            onChange={handleChangeType}
          />
        </div>
        {
          type === '2' && !finalVideoSrc && <span className="download download-disabled">视频下载</span>
        }
        {
          type === '1' && <ImgResize src={warn_img} />
        }
        {
          type === '2' && loading && <div className="loading">
            <Loading spinning />
          </div>
        }
        {
          type === '2' && !loading && finalVideoSrc && <video className="img-main-video" controls autoPlay playsInline preload="auto" tabIndex="-1" muted="muted" >
            <source src={finalVideoSrc} type="video/mp4" />
          </video>
        }
        {
          type === '2' && !loading && !finalVideoSrc && <div className="loading">
            <p>暂无现场视频</p>
          </div>
        }
      </div>
    </Modal>
  );
}
